import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { Group, Stack } from '@mantine/core';
import WhiteBox from 'src/components/WhiteBox/WhiteBox';
import Icon from '@ui/components/Icon/Icon';
import Text from '@ui/components/Text/Text';
import { useRootStore } from 'src/new_arch/providers/RootStoreProvider';

import './ThemePicker.scss';

const ThemePicker = observer( () => {
	const { colorSchemeStore } = useRootStore();
	const isDarkMode = colorSchemeStore.colorScheme === 'dark';

	return (
		<WhiteBox className="ThemePicker">
			<Stack spacing={12} p={24} align="flex-start">
				<Text variant="h3">Platform Theme</Text>
				<Text variant="body" w="100%" color="dimmed">
					Choose between Light and Dark mode. Dark mode reduces eye strain in low light,
					while Light mode offers higher contrast for bright environments.
				</Text>
				<Group spacing={12} mt={4}>
					<button
						className={classNames( 'theme-button', { selected: !isDarkMode } )}
						onClick={() => colorSchemeStore.setColorScheme( 'light' )}
					>
						<Icon icon="light-mode" size={24} />
						<Text variant="footnote-semibold">Light Mode</Text>
					</button>
					<button
						className={classNames( 'theme-button', { selected: isDarkMode } )}
						onClick={() => colorSchemeStore.setColorScheme( 'dark' )}
					>
						<Icon icon="dark-mode" size={24} />
						<Text variant="footnote-semibold">Dark Mode</Text>
					</button>
				</Group>
			</Stack>
		</WhiteBox>
	);
} );

export default ThemePicker;
